import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSpinner } from '@fortawesome/free-solid-svg-icons';
import TechList from './techList';
import russianTechnologies from './russian-technologies.json';
import internationalTechnologies from './technologies.json';
import { textSimilarity } from '../../utils/textUtils';

function Techs() {
    const { id } = useParams();
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [filteredTechnologies, setFilteredTechnologies] = useState([]);

    const allTechnologies = [
        ...russianTechnologies,
        ...internationalTechnologies
    ].filter(card => !card.title.includes('Dynatrace') && !card.title.includes('Davis Assistant'));

    useEffect(() => {
        if (searchTerm) {
            setIsLoading(true);
            const timer = setTimeout(() => {
                const filtered = allTechnologies.filter(card => {
                    const searchContent = `${card.title} ${card.content}`.toLowerCase();
                    const searchWords = searchContent.split(' ');
                    const searchTermLower = searchTerm.toLowerCase();

                    return searchWords.some(word => {
                        const similarity = textSimilarity(word, searchTermLower);
                        return similarity > 0.6;
                    });
                });
                setFilteredTechnologies(filtered);
                setIsLoading(false);
            }, 200);

            return () => clearTimeout(timer);
        } else {
            setFilteredTechnologies(allTechnologies);
        }
    }, [searchTerm]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    return (
        <div className="flex flex-col justify-center items-center pt-3 pb-4">
            <div className="text-[32px] xl:text-[44px] font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text  xl:w-[1369px] my-[40px] w-full text-center">
                Технологии
            </div>

            <div className="w-full text-center mb-3 pb-3 text-circe-rounded text-18px text-lg-28-px">
                Каталог поддерживаемых технологий, интеграций и расширений, <br className='hidden lg:inline' /> предоставляемых «Ключ-Астром» и партнерами. <br /><br /><br />
            </div>

            <div className="w-full max-w-[1000px]">
                <div className="relative flex w-full">
                    <input 
                        id="search_target" 
                        type="search" 
                        className="w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" 
                        placeholder="Введите название технологии" 
                        aria-label="Введите название технологии" 
                        aria-describedby="button-search"
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                    <button 
                        className="px-4 py-2 text-gray-700 bg-white border border-l-0 border-gray-300 rounded-r-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" 
                        type="button" 
                        id="button-search"
                    >
                        <FontAwesomeIcon 
                            icon={isLoading ? faSpinner : faSearch} 
                            className={`${isLoading ? 'fa-spin-pulse fa-spin-reverse' : ''}`} 
                        />
                    </button>
                </div>
            </div>

            <TechList technologies={filteredTechnologies} />
        </div>
    );
}

export default Techs;
